module.exports = __webpack_public_path__ + "static/media/HOME_MOBILE.127c2c9c.png";